import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=fcb63566&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=js&"
export * from "./Cookies.vue?vue&type=script&lang=js&"
import style0 from "../assets/styles/gdpr.css?vue&type=style&index=0&id=fcb63566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb63566",
  null
  
)

export default component.exports